import { bufferToHexString, hexStringToBuffer, } from '@iotize/common/byte-converter';
import { AES, enc, mode, pad, lib as CryptoJSLib } from 'crypto-js';
export class AesEcb128Converter {
    // _cipher?: Cipher;
    // _decipher?: Decipher;
    constructor(options) {
        if (options) {
            this.setOptions(options);
        }
    }
    setOptions(options) {
        if (!this._options) {
            this._options = {};
        }
        this._options.key = enc.Hex.parse(options.key);
        const ivEncode = options.hasOwnProperty('ivEncode')
            ? options.ivEncode
            : options.iv;
        this._options.ivEncode = enc.Hex.parse(ivEncode);
        const ivDecode = options.hasOwnProperty('ivDecode')
            ? options.ivDecode
            : options.iv;
        this._options.ivDecode = enc.Hex.parse(ivDecode);
    }
    get options() {
        return this._options;
    }
    encode(data) {
        if (!this._options) {
            throw new Error(`AES options have not been set yet`);
        }
        const input = enc.Hex.parse(bufferToHexString(data));
        const key = this._options.key;
        const iv = this._options.ivEncode;
        const encrypted = AES.encrypt(input, key, {
            iv: iv,
            mode: mode.CBC,
            padding: pad.NoPadding,
        });
        const encryptedHexString = enc.Hex.stringify(encrypted.ciphertext);
        return hexStringToBuffer(encryptedHexString);
    }
    decode(data) {
        if (!this._options) {
            throw new Error(`AES options have not been set yet`);
        }
        const input = enc.Hex.parse(bufferToHexString(data));
        const key = this._options.key;
        const iv = this._options.ivDecode;
        const decrypted = AES.decrypt(CryptoJSLib.CipherParams.create({
            ciphertext: input,
            iv: iv,
        }), key, {
            iv: iv,
            mode: mode.CBC,
            padding: pad.NoPadding,
        });
        return hexStringToBuffer(decrypted.toString(enc.Hex));
    }
}
